var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.element.value && !_vm.element.hidden),expression:"element.value && !element.hidden"}],staticClass:"transition ease-in-out duration-300",style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }